<template>
  <div class="sync-timeline">
    <div class="sync-timeline-node"><span class="sync-timeline-label">平台源同步</span><time>{{ timeline.source_sync_at || '未记录' }}</time></div>
    <div class="sync-timeline-node"><span class="sync-timeline-label">源记录更新</span><time>{{ timeline.source_updated_at || '未记录' }}</time></div>
    <div class="sync-timeline-node"><span class="sync-timeline-label">{{ publishedLabel }}</span><time>{{ timeline.published_at || '未记录' }}</time></div>
    <el-tooltip :content="timeline.explanation || '时间先后不能替代内容核对，请展开查看字段对照。'" placement="top">
      <el-tag size="mini" :type="timeline.level || 'info'">{{ timeline.text || '等待时间证据' }}</el-tag>
    </el-tooltip>
    <span v-if="lagText" class="sync-timeline-lag">源更新晚 {{ lagText }}</span>
  </div>
</template>

<script>
export default {
  name: 'JielvSyncTimeline',
  props: { row: { type: Object, required: true } },
  computed: {
    timeline() {
      return this.row.sync_timeline || {
        source_sync_at: this.row.source_sync_at || null,
        source_updated_at: this.row.source_updated_at || null,
        published_at: this.row.last_success_at || null,
        text: '等待时间诊断', level: 'info',
        explanation: '当前接口尚未返回时间诊断；未记录的时间不代表源同步或推送失败。',
      }
    },
    publishedLabel() {
      if (this.timeline.published_time_basis === 'room_status_snapshot') return '房态成功受理'
      if (this.timeline.published_time_basis === 'remote_query') return '捷旅目录确认'
      if (this.timeline.published_time_basis === 'successful_request_log') return '成功请求记录'
      return '捷旅成功受理'
    },
    lagText() {
      const seconds = Number(this.timeline.source_newer_seconds)
      if (!Number.isFinite(seconds) || seconds <= 0) return ''
      if (seconds < 60) return `${Math.floor(seconds)} 秒`
      if (seconds < 3600) return `${Math.floor(seconds / 60)} 分 ${Math.floor(seconds % 60)} 秒`
      if (seconds < 86400) return `${Math.floor(seconds / 3600)} 小时 ${Math.floor((seconds % 3600) / 60)} 分`
      return `${Math.floor(seconds / 86400)} 天 ${Math.floor((seconds % 86400) / 3600)} 小时`
    },
  },
}
</script>

<style scoped>
.sync-timeline { padding: 5px 0; min-width: 255px; font-size: 12px; }
.sync-timeline-node { position: relative; display: flex; justify-content: space-between; gap: 12px; padding: 2px 0 5px 13px; border-left: 1px solid #dce5ef; }
.sync-timeline-node::before { content: ''; position: absolute; left: -4px; top: 7px; width: 7px; height: 7px; border-radius: 50%; background: #409eff; }
.sync-timeline-node:last-of-type { margin-bottom: 5px; }
.sync-timeline-label { color: #606266; white-space: nowrap; }
.sync-timeline-node time { font-variant-numeric: tabular-nums; white-space: nowrap; color: #303133; }
.sync-timeline-lag { display: block; margin-top: 4px; color: #b36b00; font-size: 11px; }
</style>
